
import axios from 'axios'

/**
 * OrderController 相关接口
 */
export default {
  /**
   * 创建普通订单
   * @param {Object} data - 订单数据
   * @param {number} data.userId - 用户ID
   * @param {number} data.productId - 商品ID
   * @param {number} data.count - 购买数量
   * @param {number} data.isSeckill - 是否秒杀订单(0-否,1-是)
   * @param {number} [data.activityId] - 秒杀活动ID(秒杀订单必填)
   * @returns {Promise} - 订单编号
   */
  createOrder(data) {
    return axios({
      url: '/product-service/api/order/create',
      method: 'post',
      data
    })
  },
  
  /**
   * 获取订单详情
   * @param {string} orderSn - 订单编号
   * @returns {Promise} - 订单详情
   */
  getOrderDetail(orderSn) {
    return axios({
      url: '/product-service/api/order/getOrderDetail',
      method: 'get',
      params: { orderSn }
    })
  },
  
  /**
   * 支付订单
   * @param {string} orderSn - 订单编号
   * @param {string} payType - 支付方式(alipay/wechat)
   * @returns {Promise} - 支付结果
   */
  payOrder(orderSn, payType) {
    return axios({
      url: '/product-service/api/order/pay',
      method: 'post',
      params: { orderSn, payType }
    })
  },
  
  /**
   * 取消订单
   * @param {string} orderSn - 订单编号
   * @returns {Promise} - 取消结果
   */
  cancelOrder(orderSn) {
    return axios({
      url: '/product-service/api/order/cancel',
      method: 'post',
      params: { orderSn }
    })
  },
  
  /**
   * 获取用户订单列表
   * @param {Object} params - 查询参数
   * @param {number} params.userId - 用户ID
   * @param {number} params.pageNum - 页码
   * @param {number} params.pageSize - 每页条数
   * @param {number} [params.status] - 订单状态
   * @returns {Promise} - 订单列表
   */
  getUserOrders(params) {
    return axios({
      url: '/product-service/api/order/user',
      method: 'get',
      params
    })
  },
  
  /**
   * 确认收货
   * @param {string} orderSn - 订单编号
   * @returns {Promise} - 操作结果
   */
  confirmReceipt(orderSn) {
    return axios({
      url: '/product-service/api/order/confirm',
      method: 'post',
      params: { orderSn }
    })
  }
}